<button (click)="toggleNavBar()" class="d-block d-md-none close-menu"><i class="fa fa-times"></i></button>

<div class="userinfo d-block d-md-none" *ngIf="user?.fullname || user?.customer?.name" (click)="toggleMobileUserOptions()">
    <span class="toggle-user-options"><i class="fa fa-caret-down"></i></span>
    <span class="userfullname">{{ user?.fullname }}</span><br/>
    <span class="useremail">{{ user?.email }}</span><br/>
    <span class="customer">
      <ng-container *ngIf="user?.customer?.name">
        <span *ngIf="salesRep">{{ user?.customer?.name }}</span>
        <ng-container *ngIf="!salesRep">{{ user?.customer?.name }}</ng-container>
      </ng-container>
    </span>
</div>

<div class="mobile-user-options">

   <ul>
      <li *ngIf="salesRep"><a href="javascript:void(0)" (click)="selectCustomer()"><i class="fa fa-id-badge fa-extra-margin"></i>Change customer</a></li>
      <li><a routerLink="/logout"><i class="fa fa-sign-out"></i>Log out</a></li>
    </ul>

    <div *ngIf="languages?.length > 0">
      <h6>{{ 'lang.change-language' | translate }}</h6>
      <app-language-picker
        [languages]="languages"
        (onSelectLanguage)="toggleNavBar()">
      </app-language-picker>
    </div>

</div>

<nav
  class="d-none d-sm-block page-navbar navbar navbar-expand-md navbar-dark"
  *ngIf="menuItems?.length" >
  <div [ngClass]="{'container-fluid': fullWidthView$ | async, 'container': !(fullWidthView$ | async)}">
    <div class="row">
      <div class="col-12">
        <div class="no-collapse">
          <ul class="navbar-nav">
            <li class="nav-item" routerLinkActive="active" *ngFor="let item of topMenus">
              <!-- No child menus -->
              <a *ngIf="item?.slug && !hasChildMenus(item)" [routerLink]="item?.slug" class="nav-link" (click)="toggleNavBar()">
                {{ item?.name }}
              </a>

              <!-- Child menus -->
              <a *ngIf="item?.slug && hasChildMenus(item)" class="nav-link" (click)="toggleSubMenu(item)">
                {{ item?.name }}
                <i class="fa" [ngClass]="{ 'fa-caret-up' : showSubMenu(item), 'fa-caret-down' : !showSubMenu(item) }"></i>
              </a>

              <div class="submenu" [ngClass]="{ 'active': showSubMenu(item) }" *ngIf="item?.slug && hasChildMenus(item)">
                
                <div class="groups">

                  <div class="group" *ngFor="let childMenuGroup of getChildMenuGroups(item)">
                    <ul>
                      <li *ngFor="let subMenu of getChildMenus(childMenuGroup)">
                        <a [routerLink]="subMenu.slug" (click)="toggleSubMenu()">{{ subMenu.name }}</a>
                      </li>
                    </ul>
                  </div>

                </div>

              </div>

              <!--
              <ul class="submenu" [ngClass]="{ 'active': showSubMenu(item) }" *ngIf="item?.slug && hasChildMenus(item)">
                <li *ngFor="let subMenu of getChildMenus(item)">
                  <a [routerLink]="subMenu.slug" (click)="toggleSubMenu()">{{ subMenu.name }}</a>
                </li>
              </ul>
              -->

            </li>
           </ul>
        </div>
      </div>
    </div>
  </div>
</nav>
